import { SessionStorageKeys } from '../constants/sessionKeys';

export const getAccessToken = () =>
    sessionStorage.getItem(SessionStorageKeys.OKTA_AUTH_ACCESS_TOKEN);

export const getOktaAuthEmail = () =>
    sessionStorage.getItem(SessionStorageKeys.OKTA_AUTH_EMAIL) ?? '';

export const setAccessToken = (token: string) =>
    sessionStorage.setItem(SessionStorageKeys.OKTA_AUTH_ACCESS_TOKEN, token);

export const setOktaAuthEmail = (email: string) =>
    sessionStorage.setItem(SessionStorageKeys.OKTA_AUTH_EMAIL, email);

export const clearSessionTokens = () => {
    sessionStorage.removeItem(SessionStorageKeys.OKTA_AUTH_ACCESS_TOKEN);
    sessionStorage.removeItem(SessionStorageKeys.OKTA_AUTH_EMAIL);
};
